import styled, { css } from 'styled-components';
import { colors } from '../../theme/tokens';

export const TableWrapper = styled.div`
    background: transparent;
`;

export const StyledTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
`;

export const Thead = styled.thead``;

export const Tbody = styled.tbody``;

export const Th = styled.th<{ $active?: boolean; $align?: 'left' | 'center' | 'right'; $sortable?: boolean }>`
    padding: 10px 16px;
    text-align: ${({ $align = 'left' }) => $align};
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${({ $active }) => ($active ? '#222' : '#999')};
    border-bottom: 1px solid #eee;
    user-select: none;
    ${({ $sortable = true }) =>
        $sortable &&
        css`
            cursor: pointer;
        `}
`;

export const SortIndicator = styled.span`
    font-size: 10px;
    margin-left: 2px;
`;

export const Tr = styled.tr<{ $clickable?: boolean; $active?: boolean }>`
    border-bottom: 1px solid #f5f5f5;
    transition: background 0.1s ease;

    ${({ $clickable }) =>
        $clickable &&
        css`
            cursor: pointer;
            &:hover {
                background: #fafafa;
            }
        `}

    ${({ $active }) =>
        $active &&
        css`
            background: #fafafa;
        `}
`;

export const Td = styled.td<{ $align?: 'left' | 'center' | 'right'; $numeric?: boolean; $muted?: boolean }>`
    padding: 12px 16px;
    font-size: ${({ $muted }) => ($muted ? '12px' : '14px')};
    color: ${({ $numeric, $muted }) => ($muted ? '#999' : $numeric ? '#666' : '#111')};
    text-align: ${({ $align = 'left' }) => $align};
    ${({ $numeric }) =>
        $numeric &&
        css`
            font-variant-numeric: tabular-nums;
        `}
`;

export const EmptyRow = styled.tr`
    td {
        padding: 48px 16px;
        text-align: center;
        color: #999;
        font-size: 14px;
    }
`;

export const LoadingOverlay = styled.div`
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
`;
